module.exports = __webpack_public_path__ + "static/elemental_gem_fire-7e8adbf7a104136d1399c95ceb40db72.jpg";